import React from 'react'

import { InProgressPost, InProgressPostStep } from 'types/post'

import { WorkoutDetailsForm } from './subcomponents/WorkoutDetailsForm'
import { WorkoutStepsForm } from './subcomponents/WorkoutStepsForm'

interface WorkoutEditorFormProps {
  addStep: (insertAtIndex: number) => void
  initialData: InProgressPost
  saveDetails: (values: Partial<InProgressPost>) => void
  saveMultipleSteps: (stepsData: Partial<InProgressPostStep[]>) => void
  deleteStepAtIndex: (stepIndex: number, navigate?: boolean) => void
}

export const WorkoutEditorForm = ({
  addStep,
  initialData,
  saveDetails,
  saveMultipleSteps,
  deleteStepAtIndex,
}: WorkoutEditorFormProps): JSX.Element | null => {
  return (
    <>
      <WorkoutDetailsForm initialValues={initialData} onValuesChange={saveDetails} />
      <WorkoutStepsForm
        saveMultipleSteps={saveMultipleSteps}
        initialValues={initialData}
        onValuesChange={saveDetails}
        addStep={addStep}
        deleteStepAtIndex={deleteStepAtIndex}
      />
    </>
  )
}
